'use strict';
import defaults from 'lodash/defaults';
import noop from 'lodash/noop';
import omit from 'lodash/omit';
import {Observable} from 'rxjs/Observable';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/buffer';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/switchMap';
import {AjaxFactory, HttpMethod} from '../../_libs/redux-observable-list';
import {errorHandler} from '../../core-utilities/rx-utils';
import {CLIENT_VERSION} from '../constants';
import {BASE_REDUX_LIST_OPTIONS} from '../redux-list';

const PROP_BLACKLIST = [
  'childName',
  'level',
  'levelName',
  'msg',
  'name',
  'src',
  'time',
  'v',
  'type',
  'err',
  'request',
  'response',
];

export class ServerStream {

  $inject = [
    '$ngRedux',
    'DeviceServices',
  ];

  constructor(o) {
    const options = {};
    defaults(options, o, {
      bufferInterval: 30 * 1000,
    });
    this.options = options;
    this.requestFactory = options.requestFactory;
    this.logSubject = new ReplaySubject(100);
    this.isReady = new Subject();
    this.buildMessage = this.buildMessage.bind(this);

    this.__buildMessageStream()
      .subscribe(noop);
  }

  // separated out for testing
  __buildMessageStream() {
    return this.logSubject
      .buffer(Observable
        .merge(
          this.isReady,
          this.isReady.switchMap(() => Observable.interval(this.options.bufferInterval)),
        )
      )
      .filter(list => list.length > 0)
      .map(list => list.map(this.buildMessage))
      .mergeMap(request => {
        const rootState = this.dependencies.$ngRedux.getState();
        // TODO: Retry after successful login
        if (this.requestFactory.hasRequiredAuth(rootState)) {
          return this.requestFactory.sendRequest(request, rootState)
            .catch(errorHandler(console, 'onSendLogs', null, /* maxAttempts=*/ 20, /* multiplier=*/ 5000));
        }
      });
  }

  postConstruct() {
    this.isReady.next();
  }

  write(rec) {
    this.logSubject.next(rec);
  }

  buildMessage(rec) {
    return {
      device: this.dependencies.DeviceServices.getBuildAwareDeviceType(),
      deviceVersion: this.dependencies.DeviceServices.getDeviceVersion(),
      clientVersion: CLIENT_VERSION,
      ua: this.dependencies.DeviceServices.getUserAgent(),

      name: rec.childName || rec.name,
      msg: rec.msg,
      type: rec.type || null,
      date: rec.time.getTime(),
      src: rec.src,
      data: ServerStream.buildData(rec),
    };
  }

  static buildData(rec) {
    const data = omit(rec, PROP_BLACKLIST);
    const request = rec.request || (rec.err && rec.err.request);
    const response = rec.response || (rec.err && rec.err.request ? rec.err : null);

    if (rec.err && rec.err.request) {
      data.err = {
        message: rec.err.message,
        status: rec.err.status,
        name: rec.err.name,
      };
    } else if (rec.err) {
      data.err = {
        ...rec.err,
        name: rec.err.name,
      };
    }

    if (request) {
      data.request = {
        method: request.method,
        url: request.url,
        body: request.body,
      };
    }

    if (response) {
      data.response = {
        status: response.status,
        url: response.url,
        body: response.response,
      };
    }

    return data && Object.keys(data).length > 0 ? data : null;
  }
}

function buildAjaxFactory(options) {
  return new AjaxFactory({
    crossDomain: options.crossDomain,
    method: HttpMethod.POST,
    useBody: true,
    url: `${options.baseApiUrl}/error-log/_batch`,
    getToken: options.getToken,
    responseType: request => 'json',
  });
}

export const serverStream = new ServerStream({
  requestFactory: buildAjaxFactory({
    ...BASE_REDUX_LIST_OPTIONS,
  }),
});



// WEBPACK FOOTER //
// ./src/js/config/logger/ServerStream.js